import { Component, Input, OnDestroy } from '@angular/core';
import { ConfigurationService } from '../store/configuration.service';
import { LssConfigurationEntity } from '../store/configuration.datamodel';
import { ActorObject, ActorType } from '../../shared/datamodel';
import { AppService } from '../../application/app.service';
import { DeploymentService } from '../../deployments/store/deployment.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'ama-ng-app-store-configuration-hierarchy-list',
    templateUrl: './configuration-hierarchy-list.component.html',
    styleUrls: ['./configuration-hierarchy-list.component.scss'],
    standalone: false
})
export class ConfigurationHierarchyListComponent implements OnDestroy {
  @Input() canCreateConfiguration = false;
  @Input() areConfigurationOverridesEnabled = false;

  appId = '';
  loadedORGs: ActorObject[] = [];
  subscription: Subscription = new Subscription();

  constructor(
    protected readonly appService: AppService,
    protected readonly configurationService: ConfigurationService,
    protected readonly deploymentService: DeploymentService,
  ) {
    this.subscription.add(this.deploymentService.loadedORGs$.subscribe(loadedORGs => {
        this.loadedORGs = loadedORGs;
      })
    );
    this.subscription.add(this.appService.detailedApp$.subscribe(app => {
        this.appId = app.id ?? '';
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  selectEntity(entity: LssConfigurationEntity): void {
    if (this.appId !== '' && entity && entity.actor.actorType === ActorType.ORGANISATION &&
      !this.loadedORGs.some(org => org.actorName === entity.actor.actorName)) {
      const loadedHierarchy = entity.childrenRef.length === 0;
      this.appService.appRetrieveDeploymentAndConfigurationsByOrg(this.appId, entity.actor.actorName, loadedHierarchy);
    }
    this.configurationService.onParentActorSelected(entity);
  }

  /**
   * Toggles the selected state of the item.
   * @param item
   */
  toggleIsSelected(item: LssConfigurationEntity) {
    if (item.isSelected) {
      this.configurationService.onRemoveSelectedEntity([item]);
    } else {
      this.configurationService.onAddSelectedEntity([item]);
    }
  }

  /**
   * Toggles the expanded state of the item.
   * @param item
   */
  toggleIsExpanded(item: LssConfigurationEntity): void {
    if (item.isCollapsed) {
      this.configurationService.onExpandEntity([item]);
    } else {
      this.configurationService.onCollapseEntity([item]);
    }
  }
}
